import React from "react";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WhatsAppButton from "@/components/WhatsAppButton";
import useScrollToTop from "@/hooks/useScrollToTop";
import ClientOnly from "@/components/ClientOnly";
import Index from "./pages/Index";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import FAQ from "./pages/FAQ";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import NotFound from "./pages/NotFound";
import ServerError from "./pages/ServerError";
import TocFotos01 from "./pages/TocFotos01";
import TocFotosEventos01 from "./pages/TocFotosEventos01";
import TocFotosEventos02 from "./pages/TocFotosEventos02";
import TocRapido from "./pages/TocRapido";
import AdminLogin from "./pages/AdminLogin";
import AdminResetPassword from "./pages/AdminResetPassword";
import AdminHome from "./pages/admin";
import AdminHealth from "./pages/admin/health";
import AdminPosts from "./pages/admin/posts";
import NewPost from "./pages/admin/posts/new";
import EditPost from "./pages/admin/posts/edit";
import AdminPages from "./pages/admin/pages";
import AdminDashboard from "./pages/AdminDashboard";
import AdminSetup from "./features/admin-setup";
import TocTocCRM from "./pages/TocTocCRM";
import TocTocClientes1 from "./pages/TocTocClientes1";
import Home2 from "./pages/Home2";
import FotografiaImobiliaria from "./pages/FotografiaImobiliaria";
import TocChat from "./pages/TocChat";
import HelpCenter from "./pages/HelpCenter";
import CidadesAtendidas from "./pages/CidadesAtendidas";
import RouteAwareErrorBoundary from "@/components/common/ErrorBoundary";

// Create a stable QueryClient instance
const queryClient = new QueryClient();

export function AppContent() {
  useScrollToTop();

  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/sobre" element={<About />} />
      <Route path="/contato" element={<Contact />} />
      <Route path="/servicos" element={<Services />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/privacidade" element={<PrivacyPolicy />} />
      <Route path="/termos" element={<TermsOfService />} />
      <Route path="/cidades-atendidas" element={<CidadesAtendidas />} />
      <Route path="/toc-fotos" element={<TocFotos01 />} />
      <Route path="/toc-fotos-eventos" element={<TocFotosEventos01 />} />
      <Route path="/toc-fotos-eventos-2" element={<TocFotosEventos02 />} />
      <Route path="/toc-rapido" element={<TocRapido />} />
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="/admin-reset-password" element={<AdminResetPassword />} />
      <Route path="/admin-dashboard" element={<AdminDashboard />} />
      <Route path="/admin" element={<AdminHome />} />
      <Route path="/admin/health" element={<AdminHealth />} />
      <Route path="/admin/setup" element={<AdminSetup />} />
      <Route path="/admin/posts" element={<AdminPosts />} />
      <Route path="/admin/posts/new" element={<NewPost />} />
      <Route path="/admin/posts/:id" element={<EditPost />} />
      <Route path="/admin/pages" element={<AdminPages />} />
      <Route path="/toc-toc-crm" element={<TocTocCRM />} />
      <Route path="/toc-toc-clientes-1" element={<TocTocClientes1 />} />
      <Route path="/home-2" element={<Home2 />} />
      <Route path="/fotografia-imobiliaria" element={<FotografiaImobiliaria />} />
      <Route path="/toc-chat" element={<TocChat />} />
      <Route path="/ajuda" element={<HelpCenter />} />
      <Route path="/centraldeajuda" element={<HelpCenter />} />
      <Route path="/erro" element={<ServerError />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ClientOnly>
          <Toaster />
        </ClientOnly>
        <BrowserRouter>
          <RouteAwareErrorBoundary>
            <>
              <AppContent />
              <WhatsAppButton />
            </>
          </RouteAwareErrorBoundary>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
